import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/resource/css/reset.css';
import './assets/resource/css/common.css';
import './assets/resource/css/sub.css';
import './assets/resource/css/main.css';
import { createPinia } from 'pinia';

const app = createApp(App);
const pinia = createPinia();

app.directive('number-range', {
    mounted(el, binding) {
        const [min, max] = binding.value

        el.addEventListener('input', (e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '')
        })
        
        el.addEventListener('blur', (e) => {
            let val = Number(e.target.value) || min
            if (val > max) val = max
            if (val < min) val = min
            e.target.value = val
            e.target.dispatchEvent(new Event('input'))
        })
    }
})

app.use(router);
app.use(pinia);
app.mount('#app');
